import Image from 'next/image';
import Link from 'next/link';
import React, { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import { Autoplay, Navigation, Pagination } from 'swiper/modules';

export default function TalkSvcBox(props) {
  const [swiper, setSwiper] = useState(null);
  let [maxPageCount, setMaxPageCount] = useState(0);
  let [naviCount, setNaviCount] = useState(1);

  let [tabBtncnt, setTabBtncnt] = useState(0);

  useEffect(() => {
    // setMaxPageCount(props.data.contents.length / 4);
    Math.ceil(props.data.contents[0].contents.length / 4);
  }, []);

  useEffect(() => {
    if (swiper != null) {
      swiper.slideTo(0, 0);
    }
    Math.ceil(props.data.contents[tabBtncnt].contents.length / 4);
    setNaviCount(1);
  }, [tabBtncnt]);

  const [touchX, setTouchX] = useState(0);
  const [touchY, setTouchY] = useState(0);

  const touchStart = (e) => {
    setTouchX(e.changedTouches[0].pageX);
    setTouchY(e.changedTouches[0].pageY);
  };

  const touchEnd = (e) => {
    let diffX = touchX - e.changedTouches[0].pageX,
      diffY = touchY - e.changedTouches[0].pageY;

    Math.abs(diffX) > Math.abs(diffY)
      ? 0 < diffX
        ? swiper.slideNext()
        : swiper.slidePrev()
      : 0 < diffY
      ? console.log('to top')
      : console.log('to bottom');
  };
  useEffect(() => {
    //alert('www');
    window.__SBSLogModuleDataLayer = window.__SBSLogModuleDataLayer || [];
  }, []);
  //link로그를
  const handleClick = (a, b, c, d) => {
    let moduleSubTitle;
    let contentTitle;
    let contentId;
    if (d === 'live') {
      moduleSubTitle = '실시간라이브';
      contentTitle = b.title;
      contentId = b.channelid;
    } else if (d === '24') {
      moduleSubTitle = '24시간TV';
      contentTitle = b.title;
      contentId = b.channelid;
    } else {
      moduleSubTitle = '전체채널';
      contentTitle = '';
      contentId = '';
    }

    //통계에 넙겨줄 값을정리한다,상단여역 pgmbox 프로그램 / 메뉴 / 플레이톡이 있음

    window.__SBSLogModuleDataLayer.push({
      type: 'content',
      option: {
        moduleId: '라이브', //모듈 아이디 없으면
        moduleTitle: '실시간라이브/24시간TV', //모듈 제목 (Require)
        moduleSubTitle: moduleSubTitle,
        moduleActive: 'C', //콘텐츠 선택 정보 Click: C, Hover: H
        moduleSeq: props.loc_idx, //페이지에서 해당 모듈의 위치
        moduleItemSeq: c, //모듈 내에서 콘텐츠의 위치
        programId: '', //프로그램의 아이디 (추가)
        programTitle: '', //프로그램의 제목 (추가)
        contentId: contentId, //식별자
        contentTitle: contentTitle, //콘텐츠의 제목  (Require)
        contentType: 'L', //콘텐츠의 타입 (별도 표 참조)
      },
    });
  };

  const handleClick_custom = (a, b, c, d) => {
    window.__SBSLogModuleDataLayer.push({
      type: 'click',
      option: {
        clickName: '플레이톡최상단타이틀',
        clickType: 'NC',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
      },
    });
  };

  return (
    <>
      {/* <!-- 그레이 배경 -->*/}
      <div className="mainContents-typeGray">
        {/* <!-- playtalk 타이틀 배너 -->*/}
        <div className="contentsBlock_w playtalkBanner_w">
          <a
            href="https://www.sbs.co.kr/playtalk"
            onClick={(e) => handleClick_custom(e, '', '0', 'all')}
            className="playtalkBnrLink"
          >
            <div className="playtalkBnrLine">
              <strong className="iconSvg_playtalk">
                <i className="hide">playtalk</i>
              </strong>
              <span className="playtalkBnr-name">플레이톡</span>
            </div>
            <div className="playtalkBnrLine">
              <span className="playtalkBnr-title">이야기의 즐거움을 잇다!</span>
              <span className="playtalkBnr-arrow">
                <i className="iconSvg_arrow"></i>
              </span>
            </div>
          </a>
        </div>
        {/* <!-- playtalk 탭 list -->*/}

        {/* <!-- 플레이톡 리스트 -->*/}
        <div className="contentsBlock_w">
          <div className="tabBtns_w_sortBasic">
            {props.data.contents.map((item, index) => {
              return (
                <a
                  onClick={() => setTabBtncnt(index)}
                  className={`tabBtn_typeText${
                    tabBtncnt == index ? ' current' : ''
                  }`}
                >
                  <span className="tabBtn_text">{item.tab_name}</span>
                </a>
              );
            })}
          </div>
          <div className={'listModule_w_playtalk playtalk' + props.loc_idx}>
            <Swiper
              onSwiper={(s) => {
                //console.log("initialize swiper", s);
                setSwiper(s);
              }}
              allowTouchMove={false} //수동 제어하기위해 멈춤
              slidesPerView={2}
              spaceBetween={24}
              slidesPerGroup={2}
              loop={false}
              pagination={{
                // 페이징 설정
                el: `.playtalk${props.loc_idx} .swiper-pagination`,
                type: 'fraction',
              }}
              breakpoints={{
                375: {
                  slidesPerView: 2,
                  spaceBetween: 10,
                },
                768: {
                  slidesPerView: 4,
                  spaceBetween: 10,
                },
              }}
              navigation={{
                nextEl: `.playtalk${props.loc_idx} .swiper-button-next`,
                prevEl: `.playtalk${props.loc_idx} .swiper-button-prev`,
              }}
              modules={[Autoplay, Pagination, Navigation]}
              className="listModuleSlider"
              wrapperClass="SliderContent"
            >
              {props.data.contents[tabBtncnt].contents.map((item, index) => {
                maxPageCount = Math.ceil(
                  props.data.contents[tabBtncnt].contents.length / 4
                );

                const handleOpenPopup = () => {
                  window.__SBSLogModuleDataLayer.push({
                    type: 'click',
                    option: {
                      clickName: '톡모듈',
                      clickType: 'NC',
                      value1: item.talk_title,
                      value2: item.talk_id,
                      value3: '',
                      value4: '',
                      value5: '',
                    },
                  });

                  //  485 * 928
                  const popup = window.open(
                    'https://www.sbs.co.kr/playtalk/module.html?code=' +
                      item.talk_id,
                    '타이틀명을 입력하시오',
                    'top=0, left=0, width=485, height=928, status=no, menubar=no, toolbar=no, resizable=no'
                  );
                };
                try {
                  return (
                    <SwiperSlide
                      key={`swiper-slide-${index}`}
                      onTouchStart={touchStart}
                      onTouchEnd={touchEnd}
                    >
                      <div className="listModuleItem swiper-slide">
                        <div
                          className={`modulePlaytalkWrap${
                            item.star_submit_yn === 'Y'
                              ? ' playtalkStar-on'
                              : ''
                          }${item.live_yn === 'Y' ? ' playtalkLive-on' : ''} `}
                        >
                          {/* <!-- 스타 참여중 : playtalkStar-on / 라이브 : playtalkLive-on -->*/}
                          <div className="mpt_inner">
                            <a
                              onClick={handleOpenPopup}
                              href="#none"
                              className="mpt_link"
                            >
                              <div className="mpt_image_w">
                                <div className="mpt_image_inner">
                                  <img
                                    src={item.talk_img}
                                    className="mpt_image"
                                    alt={item.talk_title}
                                  />
                                </div>
                              </div>
                              <strong className="mbt_title">
                                {item.talk_title}
                              </strong>
                            </a>
                            <div className="mpt_bottomBtn">
                              <a
                                onClick={handleOpenPopup}
                                href="#none"
                                className={`btnType-playtalk btnOpenType-playtalk${
                                  item.wagel_yn === 'Y'
                                    ? ' aniType-playtalk'
                                    : ''
                                }`}
                              >
                                {/* <!-- 와글 : aniType-playtalk -->*/}
                                <span className="aniPlaytalk_w">
                                  <span className="iconSvg_aniPlaytalk">
                                    <i className="hide">와글</i>
                                  </span>
                                  <i className="iconSvg_shadow"></i>
                                </span>
                                <span className="iconSvg_playtalk"></span>
                                <strong className="btnType-title">
                                  플레이톡
                                </strong>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  );
                } catch (error) {}
              })}
            </Swiper>
            <div className="sliderBottom_w">
              <button
                type="button"
                className="btnLineTypeList-Next swiper-button-next"
                onClick={() => setNaviCount(naviCount + 1)}
              >
                <span className="iconSvg_arrow">
                  <i className="hide">다음</i>
                </span>
              </button>
              <div className="swiper-pagination notranslate"></div>
              <button
                type="button"
                aria-label="이전 콘텐츠 보기"
                className="btnLineTypeList-Prev swiper-button-prev"
                onClick={() => setNaviCount(naviCount - 1)}
              >
                <span className="iconSvg_arrow">
                  <i className="hide">이전</i>
                </span>
                <span className="pagingNumber_w">
                  <strong className="pagingNumber-now">{naviCount}</strong>/
                  {maxPageCount}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
